<template>
  <div class="header">
    <Logo />

    <div class="actions" v-if="$store.getters.showDashboard">
      <div class="project-title">
        <h5 class="no-margin">
          Project:
          <span v-text="projectTitle"></span>
        </h5>
      </div>
      <zi-button shadow type="success" @click="switchProject">
          Switch project.
        </zi-button>
    </div>
  </div>
</template>

<script>
import Logo from './Logo'

export default {
  name: 'Header',
  components: { Logo },
  computed: {
    projectTitle() {
      return this.$store.getters.project.name_with_namespace
    },
  },
  methods: {
    switchProject() {
      this.$store.commit('SET_SELECTED_PROJECT', null)
      this.$store.commit('SET_LABELS', [])
      this.$store.commit('RESET_ISSUES')

      this.$router.push({ name: 'select-project' })
    }
  }
}
</script>

<style scoped>
.header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.no-margin {
  margin-bottom: 0;
}
.project-title {
    margin-right: 30px;
}
.actions {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>